// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (min-width:751px){.intro-sf-banner-pc[data-v-c48ff504]{display:block}.intro-sf-banner-mobile[data-v-c48ff504]{display:none}}@media screen and (max-width:750px){.intro-sf-banner-pc[data-v-c48ff504]{display:none}.intro-sf-banner-mobile[data-v-c48ff504]{display:block}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
